// extracted by mini-css-extract-plugin
module.exports = {"cartItem-desc":"jtHZZ","cartItem-desc--mods":"_4r8dZ","info":"rKbGB","title":"Htvqf","actions":"Jj0GP","card":"jpxeA","image":"EIZY1"};